var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrustedAccountIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12C13.21 12 15 10.21 15 8C15 5.79 13.21 4 11 4C8.79 4 7 5.79 7 8C7 10.21 8.79 12 11 12ZM11 6C12.1 6 13 6.9 13 8C13 9.1 12.1 10 11 10C9.9 10 9 9.1 9 8C9 6.9 9.9 6 11 6ZM9.96 16.06C7.57 16.32 5.2 17.37 5 18H10L12 20H3V18C3 15.34 8.33 14 11 14C11.32 14 11.61 14.02 12 14.06L9.96 16.06Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.24 13L14.623 17.5238L12.76 15.7037L11.5 16.9375L14.623 20L20.5 14.2337L19.24 13Z",
    fill: "#65C466"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedAccountIcon);
export default __webpack_public_path__ + "static/media/trusted-account-icon.d4c4a6610ab76fc95df44149e92eab6b.svg";
export { ForwardRef as ReactComponent };